import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RedirectOrder from './components/redirect/RedirectOrder';
import RedirectPayment from './components/redirect/RedirectPayment';
import RedirectWintripjapan from './components/redirect/RedirectWintripjapan';
import Home from './pages/Home';
import Promo from './pages/Promo';
import Download from './pages/Download';
import Page from './pages/Page';

function App() {

  return (
    <Router basename={process.env.PUBLIC_URL}>
      {/* <Router basename="/fmi-compro"> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/promo" element={<Promo />} />
        <Route path="/famigo-download" element={<Download />} />
        <Route path="/new-page" element={<Page />} />

        <Route path="/payment-linking-process/:platform" element={<RedirectPayment />} />
        <Route path="/order-detail/:orderId" element={<RedirectOrder />} />
        <Route path="/winatriptojapan" element={<RedirectWintripjapan />} />
      </Routes>
    </Router>
  );
}

export default App;
